import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { ApolloLink, from, split } from "apollo-link";
import { onError } from "apollo-link-error";
import { withClientState } from "apollo-link-state";
import { WebSocketLink } from "apollo-link-ws";
import { createUploadLink } from "apollo-upload-client";
import { getMainDefinition } from "apollo-utilities";
import React from "react";
import { ApolloProvider } from "react-apollo";
import resolvers from "./resolvers.local";
import Routes from "./Routes";

const getToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token") || null;

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: getToken()
    }
  }));
  return forward(operation);
});

const wsLink = () => {
  return new WebSocketLink({
    uri: `${process.env.REACT_APP_WS_URL}/subscriptions`,
    options: {
      reconnect: true,
      connectionParams: {
        authToken: getToken()
      }
    }
  });
};

const uploadLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/api`
});

const cache = new InMemoryCache({
  dataIdFromObject: o => {
    switch (o.__typename) {
      case "Addon":
        return `${o.id}${
          o.items
            ? o.items.map(item => `${item.id}-${item.price}`).join("-")
            : ""
        }`;
      default:
        return o.id || null;
    }
  }
});

const stateLink = withClientState({
  defaults: {
    removedItmes: {
      removedItems: [],
      __typename: "RemovedItems"
    },
    menuRequestItems: {
      menuRequestItems: [],
      __typename: "MenuRequestItems"
    },
    isLoggedIn: {
      isLoggedIn:
        !!localStorage.getItem("token") || !!sessionStorage.getItem("token"),
      __typename: "IsLoggedIn"
    }
  },
  resolvers,
  cache
});

const errorLink = onError(
  ({ graphQLErrors, networkError, response, operation }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
            locations
          )}, Path: ${path}`
        )
      );
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }

    if (operation.operationName === "IgnoreErrorsQuery") {
      response.errors = null;
    }
  }
);

const client = new ApolloClient({
  link: split(
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === "OperationDefinition" && operation === "subscription";
    },
    wsLink(),
    from([errorLink, authMiddleware, stateLink, uploadLink])
  ),
  resolvers,
  cache
});

class App extends React.PureComponent {
  render() {
    return (
      <ApolloProvider client={client}>
        <Routes />
      </ApolloProvider>
    );
  }
}

export default App;

/*

http://localhost:3001/#/connexion/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVjZWJjYzFhMGY4NTA5MDI0NTE2Nzk2NiIsInByb2ZpbGUiOnsiZmlyc3ROYW1lIjoiSGFraW0iLCJsYXN0TmFtZSI6IkxvdXJndWlvdWkifSwiZW1haWwiOiJyZXN0YXVyYW50QGdtYWlsLmNvbSIsIm1vYmlsZSI6IiszMzEyMzQ1NzAwIiwiZW1haWxWZXJpZmllZCI6dHJ1ZSwibW9iaWxlVmVyaWZpZWQiOmZhbHNlLCJzdG9yZSI6IjVjZWNmNWVhNDc1MmZjNGNmNjhlOGMyZSIsInN0YXR1cyI6IkFDVElWRSIsImNyZWF0ZWRBdCI6MTU1ODk1NzA4MjYzNSwiaWF0IjoxNTc1MDIzMDcyLCJleHAiOjE1NzUwNjYyNzJ9.P-awhH1AjFSWsShbqKDsQgTMDAIGmiiQiG6bNRwvRBg
*/
